import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/ApplicationContext";
import { Button, Form, Modal } from "react-bootstrap";
import { getParkedOrders } from "../../../services/Service";
import { Table } from "semantic-ui-react";
import { IPark } from "../../../types/IPark";
import { IReceiptRow } from "../../../types/IReceiptRow";

export interface IParkedReceiptProps {
  close(): void;
  showOrder(): void;
  show: boolean;
}

export const ParkedReceipt: React.FC<IParkedReceiptProps> = (
  props: IParkedReceiptProps
): JSX.Element => {
  const context = useContext(ApplicationContext);
  const defaultPark: IPark[] = [];

  const [loading, setLoading] = React.useState(false);
  const [parked, setParked] = React.useState(defaultPark);

  async function parkedOrders() {
    if (!props.show) {
      return;
    }

    setLoading(true);

    const response = await getParkedOrders(
      context.AuthenticatedUser.getToken()
    );

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    setParked(response);
    setLoading(false);
  }

  useEffect(() => {
    parkedOrders();
  }, [props.show]);

  function onParkedClicked(p: IPark) {
    const rows: IReceiptRow[] = JSON.parse(p.receiptData);
    context.Receipt.setRows(rows);
    context.Receipt.setTable(p);
    context.Receipt.setTransactionType("Eat in");
    props.showOrder();
  }

  function formatTime(now: Date) {
    const dt = new Date(now);

    return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
  }

  const content = () => (
    <>
      <Table selectable>
        <Table.Body>
          {parked.map((p) => (
            <Table.Row
              onClick={() => {
                onParkedClicked(p);
              }}
            >
              <Table.Cell width={5} height={60}>
                {formatTime(p.createdAt)}
              </Table.Cell>
              <Table.Cell>{p.description1}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );

  const parkedView = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Parked receipts</Modal.Title>
          </Modal.Header>
          <Modal.Body>{content()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="info"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: "16px",
                  fontWeight: "bolder",
                }}
                onClick={() => props.close()}
              >
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      <>{parkedView()}</>
    </>
  );
};
